import "reflect-metadata";
export function addMetadata(key, value) {
  return function (target, propertyKey, descriptor) {
    Reflect.defineMetadata(key, value, target, propertyKey);
  };
}